// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__13usm","info":"UpdateTermsInfo_info__H9OOQ"};